/** What the user picked; unset until they opt in or switch back. */
export type ReturnsExperienceChoice = "new" | "classic";

export interface ReturnsExperienceInput {
  teamInRollout: boolean;
  /** A Redo user on a team where Redo users start in the new experience. */
  redoUserInRollout: boolean;
  choice: ReturnsExperienceChoice | undefined;
}

/**
 * The returns home and details pages are one experience. A team in the
 * rollout stays classic until the user opts in, and is invited until they
 * choose. Redo users skip the invite: they start in the new experience and
 * switch freely.
 */
export function resolveReturnsExperience({
  teamInRollout,
  redoUserInRollout,
  choice,
}: ReturnsExperienceInput): {
  useNewUi: boolean;
  canSwitch: boolean;
  undecided: boolean;
} {
  const available = teamInRollout || redoUserInRollout;
  const startsNew = redoUserInRollout && choice === undefined;
  return {
    useNewUi: available && (choice === "new" || startsNew),
    canSwitch: available,
    undecided: available && !redoUserInRollout && choice === undefined,
  };
}
